module.exports = __webpack_public_path__ + "img/exchange2.e7244d57.jpg";